import { Component, ViewChild } from '@angular/core';
import { DxPivotGridComponent } from 'devextreme-angular/ui/pivot-grid';
import { PivotGridDataSourceOptions } from 'devextreme/ui/pivot_grid/data_source';
import moment from 'moment/moment';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { LoggerService } from '../../../../shared/sdk';

@Component({
  selector: 'app-meals-claims-pivot',
  templateUrl: './meals-claims-pivot.component.html',
  styleUrls: ['./meals-claims-pivot.component.scss'],
})
export class MealsClaimsPivotComponent extends ABaseComponent {
  @ViewChild(DxPivotGridComponent, { static: false }) grid: DxPivotGridComponent;

  dso: any;
  grid_stateStoring: any;

  showTotalsPrior = false;
  rowsDataFieldArea = false;
  treeHeaderLayout = false;

  showColumnTotals = true;
  showRowTotals = true;
  showColumnGrandTotals = true;
  showRowGrandTotals = true;

  collection = 'MealClaimsPivotData';
  exportFileName = 'Meal_Claims_Pivot_' + moment().format('YYYY-MM-DD HH:mm:ss');

  constructor(
    public logger: LoggerService,
    protected dss: DataSourceService,
  ) {
    super(logger);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: 'ecf37ade-94b1-414b-bc8e-135fb7f146c1',
    };

    this.dso = {
      remoteOperations: true,
      retrieveFields: false,
      store: this.dss.createMongoStore(this.collection),
      fields: [
        { dataField: '_id', visible: false },
        { area: 'column', dataField: 'periodFrom', dataType: 'date', groupInterval: 'year' },
        { area: 'column', dataField: 'periodFrom', dataType: 'date', groupInterval: 'quarter' },
        { area: 'column', dataField: 'periodFrom', dataType: 'date', groupInterval: 'month' },
        // { dataField: 'periodFrom', dataType: 'date', groupInterval: 'day' },

        { dataField: 'mco', caption: 'MCO', dataType: 'string', isMeasure: false, area: 'row' },
        { dataField: 'code', caption: 'Code', dataType: 'string', isMeasure: false, area: 'row' },
        { dataField: 'tenant', caption: 'Tenant', dataType: 'string', isMeasure: false, area: 'row' },
        { dataField: 'client', caption: 'Client', dataType: 'string', isMeasure: false, area: 'row' },
        { dataField: 'mci', caption: 'MCI', dataType: 'string', isMeasure: false, area: 'row' },
        { dataField: 'memberId', caption: 'Member Id', dataType: 'string', isMeasure: false, area: 'row' },

        ...[
          // ['signUnits', 'Signed Units'],
          ['authUnits', 'from Auths Units'],

          ['chcBilledUnits', 'billed CHC Units'],
          ['chcPaidUnits', 'paid CHC Units'],

          ['stediBilledUnits', 'billed Stedi Units'],
          ['stediAcceptedUnits', 'accepted Stedi Units'],
          ['stediPendedUnits', 'pended Stedi Units'],
          ['stediFinalizedUnits', 'finalized Stedi Units'],
          ['stediPaidUnits', 'paid Stedi Units'],
          ['stediVoidedUnits', 'voided Stedi Units'],
          ['stediRejectedUnits', 'rejected Stedi Units'],

          ['hhaBilledUnits', 'billed HHA Units'],
          ['hhaPaidUnits', 'paid HHA Units'],
        ].map(i => ({
          dataField: i[0],
          caption: i[1],
          area: 'data',
          dataType: 'number',
          summaryType: 'sum',
          isMeasure: true,
        })),

        ...[
          // ['signAmount', 'Signed Amount'],
          ['authAmount', 'from Auths Amount'],

          ['chcBilledAmount', 'billed CHC Amount'],
          ['chcPaidAmount', 'paid CHC Amount'],

          ['stediBilledAmount', 'billed Stedi Amount'],
          ['stediAcceptedAmount', 'accepted Stedi Amount'],
          ['stediPendedAmount', 'pended Stedi Amount'],
          ['stediFinalizedAmount', 'finalized Stedi Amount'],
          ['stediPaidAmount', 'paid Stedi Amount'],
          ['stediVoidedAmount', 'voided Stedi Amount'],
          ['stediRejectedAmount', 'rejected Stedi Amount'],

          ['hhaBilledAmount', 'billed HHA Amount'],
          ['hhaPaidAmount', 'paid HHA Amount'],
        ].map(i => ({
          dataField: i[0],
          caption: i[1],
          area: 'data',
          dataType: 'number',
          format: 'currency',
          summaryType: 'sum',
          isMeasure: true,
        })),
      ],
    } as PivotGridDataSourceOptions;
  }
}
